<template>
  <div>
    <ul id="stepper_indicator" :style="{marginBottom: marginBottom}">
      <li v-for="(step, index) in steps"
          :key="index"
          :class="{ 'active': step.active, 'complete': step.isComplete }">
        <span class="circle" @click="go(index)"></span>
        <div class="caption">{{ step.name }}</div>
      </li>
    </ul>
    <div :class="bodyClasses" class="step_body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stepper",
  props: {
    marginBottom: { type: String, default: "20px" },
    bodyClasses: { type: String, default: "" },
  },
  mounted() {
    this.steps = this.$children;
    if (this.steps.length > 0) {
      this.steps[0].activate();
    }
  },
  data() {
    return {
      current: 0,
      steps: []
    };
  },
  methods: {
    next(ctx) {
      if (!this.steps.length) return;
      this.steps[this.current].complete();
      if (this.current + 1 >= this.steps.length) return;
      this.steps[this.current].deactivate();
      this.current++;
      this.steps[this.current].ctx = ctx || {};
      this.steps[this.current].activate();
      this.setHash();
    },
    go(i) {
      if (i < 0 || i >= this.current) return;
      for (let j = this.current; j > i; j--) {
        this.steps[j].unwind();
        this.steps[j].deactivate();
      }
      this.current = i;
      this.steps[i].activate();
      this.setHash();
    },
    setHash() {
      if (this.current > 0) {
        window.location.hash = "#" + this.current;
      }
    }
  },
  computed: {
    hash() {
      return this.$route.hash;
    },
  },
  watch: {
    hash(val) {
      val = Number(val.substr(1));
      if (val !== this.current) {
        this.go(val);
      }
    },
  }
};
</script>

<style scoped>
#stepper_indicator {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: step;
  text-align: center;
}

#stepper_indicator > li {
  position: relative;
  flex-grow: 1;
  flex-basis: 1em;
  flex-shrink: 1;
}

#stepper_indicator > li:after {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  top: 1rem;
  left: 50%;
  height: 3px;
  transform: translateY(-1px);
  z-index: 10;
  background-color: #969696;
}

#stepper_indicator > li.complete:after {
  background-color: #4a8b2f;
}

#stepper_indicator > li:last-child:after {
  content: none;
}

#stepper_indicator > li > .circle {
  display: inline-block;
  width: 0;
  height: 0;
  padding: 1rem;
  border-radius: 50%;
  background-color: #969696;
  line-height: 1;
  position: relative;
  counter-increment: step;
  z-index: 20;
}

#stepper_indicator > li.active > .circle {
  background-color: #fecb17;
}

#stepper_indicator > li.complete > .circle,
#stepper_indicator > li.active.complete > .circle {
  background-color: #4a8b2f;
  cursor: pointer;
}

#stepper_indicator > li > .circle:after {
  content: counter(step);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  font-weight: bold;
}

#stepper_indicator > li.complete > .circle:after {
  content: "\2713";
}

#stepper_indicator > li > .caption {
  font-size: 1.2rem;
}

@media screen and (max-width: 600px) {
  #stepper_indicator > li > .caption {
    display: none;
  }
}
</style>